import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/listpage/finance/Template'

const Finance: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'事例 実績 金融 保険 信託 証券 生命保険 損害保険 共済'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/cases/finance/'}
        title="金融/不動産 | 事例 | Aitria（アイトリア）"
        description="金融/不動産のケーススタディを紹介します｜クラウドネイティブ、AI駆動開発、デザインシステムに精通した様々な支援実績がございます。UX/UIデザイン、モダンスタック技術、CI/CD、DevOps環境、AIエージェントをフル活用した開発スタイルで顧客のデジタルシフトを支援します。"
      />
      <Template pageId={1} />
    </>
  )
}

export default Finance
